const cartFragment = `
      createdAt
      updatedAt
      checkoutUrl
      id
      discountAllocations {
        discountApplication {
            targetSelection
            targetType
            allocationMethod
            value {
                ... on MoneyV2 {
                    amount
                    currencyCode
                }
            }   
        }
        discountedAmount {
            currencyCode
            amount
        }
        targetType
      }
      discountCodes {
        code
        applicable
      }
      cost {
          totalAmount {
            currencyCode 
            amount
          }
          subtotalAmount {
            currencyCode
            amount
          }
      }
      lines(first: 100) {
        edges {
          node {
            id
            quantity
            attributes {
              key
              value
            }
            merchandise {
              ... on ProductVariant {
                id
                title
                image {
                  altText
                  url
                }
                compareAtPrice {
                  currencyCode
                  amount
                }
                price {
                  currencyCode
                  amount
                }
                selectedOptions {
                  name
                  value
                }
                product {
                  id
                  productType
                  handle
                  title
                  priceRange {
                    minVariantPrice {
                      currencyCode
                      amount
                    }
                  }
                }
              }
            }
          }
        }
      }
`;

export const checkoutErrorsFragment = `
    userErrors {
      message
      code
      field
    }
`;

export const checkoutWarningFragment = `
    warnings {
        message
        code
        target
    }
`;

export const createCartQuery = `
    mutation cartCreate($input: CartInput) {
      cartCreate(input: $input) {
        cart {
          ${cartFragment}
        }
        ${checkoutErrorsFragment}
        ${checkoutWarningFragment}
      }
    }
`;

export const getCartQuery = `query cart($checkoutId: ID!) {
        cart(id: $checkoutId) {
            ${cartFragment}
        }
    }
  `;

export const addLineItemQuery = `
  mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        ${cartFragment}
      }
      ${checkoutErrorsFragment}
    }
  }
  `;

export const updateLineItemQuery = `
  mutation cartLinesUpdate($cartId:ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        ${cartFragment}
      }
      ${checkoutErrorsFragment}
    }
  }
  `;

export const applyDiscountCodeQuery = `
  mutation cartDiscountCodesUpdate($cartId:ID!, $discountCodes: [String!]!) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      cart {
        ${cartFragment}
      } 
      ${checkoutErrorsFragment}
    }
  }
  `;

export const removeDiscountCodeQuery = `
  mutation checkoutDiscountCodeRemove($checkoutId:ID!) {
    checkoutDiscountCodeRemove(checkoutId: $checkoutId) {
      checkout {
        ${cartFragment}
      }
      ${checkoutErrorsFragment}
    }
  }
  `;

// export const associateCustomerWithCheckoutQueryV2 = `
//   mutation checkoutCustomerAssociateV2($checkoutId: ID!, $customerAccessToken: String!) {
//     checkoutCustomerAssociateV2(checkoutId: $checkoutId, customerAccessToken: $customerAccessToken) {
//       checkout {
//         webUrl
//       }
//       customer {
//         id
//         displayName
//         defaultAddress {
//           address1
//           address2
//           city
//           country
//           firstName
//           phone
//           lastName
//           province
//           zip
//         }
//       }
//       checkoutUserErrors {
//         message
//       }
//     }
//   }
//   `;
// export const associateAddressWithCheckoutQueryV2 = `
//   mutation checkoutShippingAddressUpdateV2($checkoutId: ID!, $shippingAddress: MailingAddressInput!) {
//     checkoutShippingAddressUpdateV2(checkoutId: $checkoutId, shippingAddress: $shippingAddress) {
//       checkout {
//         webUrl
//         shippingAddress {
//           address1
//           address2
//           city
//           country
//           firstName
//           phone
//           lastName
//           province
//           zip
//         }
//       }
//       checkoutUserErrors {
//         message
//       }
//     }
//   }
//   `;
